import { notification } from "antd";
export const onError = (error, defaultMessage) => {
    let errorMessage = defaultMessage;
    if (error instanceof Error) {
        errorMessage = error.message;
    }
    if (typeof error === "string") {
        errorMessage = error;
    }
    notification.error({
        message: "Ошибка",
        description: errorMessage,
    });
};
